import React from 'react';
import PaymentSummary from './PaymentSummary';
import StripeCheckoutWrapper from './StripeCheckoutWrapper';
import { Product } from 'ai-api/types/purchase';
import { Teacher } from './TeacherCard';

interface PaymentSectionProps {
    product: Product | null;
    selectedTeacher: Teacher | null;
    selectedDate: Date | null;
    selectedTime: Date | null;
    clientSecret: string | null;
    onSuccess: () => void;
    onCancel: () => void;
}

const PaymentSection: React.FC<PaymentSectionProps> = ({
    product,
    selectedTeacher,
    selectedDate,
    selectedTime,
    clientSecret,
    onSuccess,
    onCancel
}) => {
    return (
        <div className="payment-section">
            <PaymentSummary
                product={product}
                selectedTeacher={selectedTeacher}
                selectedDate={selectedDate}
                selectedTime={selectedTime}
            />
            
            <StripeCheckoutWrapper
                product={product}
                clientSecret={clientSecret}
                onSuccess={onSuccess}
                onCancel={onCancel}
            />
        </div>
    );
};

export default PaymentSection;